import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { components } from '../components';

const termsAndConditions = [
    {
        id: 1,
        title: '1. Acceptance of Terms',
        content:
            'By accessing and using our PG booking platform, you agree to comply with and be bound by these Terms and Conditions. If you do not agree with any part of the terms, you must not use our services.',
    },
    {
        id: 2,
        title: '2. Services Provided',
        content:
            'We provide a platform for users to search, compare, and book Paying Guest (PG) accommodations. We are not property owners but facilitate communication and transactions between tenants and PG owners.',
    },
    {
        id: 3,
        title: '3. User Responsibilities',
        content:
            'You agree to provide accurate information during registration and bookings. You are solely responsible for interactions with PG owners and verifying property details before making any commitments.',
    },
    {
        id: 4,
        title: '4. Booking and Payments',
        content:
            'All bookings are subject to availability and confirmation by the PG owner. Payment terms may vary per property and are governed by the agreements between tenants and PG providers.',
    },
    {
        id: 5,
        title: '5. Cancellation and Refunds',
        content:
            'Cancellation policies vary by PG and are displayed at the time of booking. Refunds, if any, are handled according to the respective PG owner’s policy and not by our platform.',
    },
    {
        id: 6,
        title: '6. Limitation of Liability',
        content:
            'We are not liable for any damages, losses, or disputes that arise from interactions or transactions between users and PG owners. We do not guarantee the accuracy or availability of listings.',
    },
    {
        id: 7,
        title: '7. Modifications to Terms',
        content:
            'We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on the platform. Continued use of our services constitutes acceptance of those changes.',
    },
    {
        id: 8,
        title: '8. Termination',
        content:
            'We reserve the right to suspend or terminate your access to the platform if you violate these terms or engage in fraudulent or harmful behavior.',
    },
    {
        id: 9,
        title: '9. Contact Information',
        content:
            'For any questions or concerns regarding these Terms and Conditions, please contact us at support@yourpgplatform.com.',
    },
];

export const TermsAndConditions: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    const renderHeader = (): JSX.Element => {
        return <components.Header title="Terms & Conditions" goBack={true} />;
    };

    const renderContent = (): JSX.Element => {
        return (
            <main className="container" style={{ paddingBottom: 0 }}>
                <div style={{ marginTop: '10%', marginBottom: 20 }}>
                    {termsAndConditions.map((item) => (
                        <div key={item.id} style={{ marginBottom: '10%' }}>
                            <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
                            <text.T14>{item.content}</text.T14>
                        </div>
                    ))}
                </div>
            </main>
        );
    };

    return (
        <>
            {renderHeader()}
            {renderContent()}
        </>
    );
};
